(function () {
  if (window.OMBQuickAdd) return;

  var CONFIG = window.OMB_CONFIG || {};
  var ROOT = CONFIG.root || '/';
  if (ROOT.slice(-1) !== '/') ROOT += '/';
  var CART_URL = CONFIG.cartUrl || '/cart';
  var MONEY_FORMAT = CONFIG.moneyFormat || 'Rs. {{amount}}';
  var SHOP_URL = CONFIG.shopUrl || window.location.origin;
  var OUT_OF_STOCK_TEXT = 'Out of stock';
  var THANKS_DURATION = 2000;

  /* ---------------- Helpers ---------------- */
  function formatMoney(cents) {
    cents = Number(cents) || 0;
    function withDelims(num, decimals, thousands, decimal) {
      var parts = (num / 100).toFixed(decimals).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return parts.join(decimal);
    }
    return String(MONEY_FORMAT).replace(/\{\{\s*(\w+)\s*\}\}/, function (_, key) {
      switch (key) {
        case 'amount_no_decimals': return withDelims(cents, 0, ',', '.');
        case 'amount_with_comma_separator': return withDelims(cents, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return withDelims(cents, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return withDelims(cents, 2, "'", '.');
        default: return withDelims(cents, 2, ',', '.');
      }
    });
  }

  function renderPriceInto(el, price, compare) {
    el.textContent = '';
    var main = document.createElement('span');
    main.textContent = formatMoney(price);
    if (compare && compare > price) {
      var old = document.createElement('span');
      old.className = 'omb-price-compare';
      old.textContent = formatMoney(compare);
      main.className = 'omb-price-sale';
      el.appendChild(old);
      el.appendChild(main);
    } else {
      el.appendChild(main);
    }
  }

  function sizedImage(src, width) {
    if (!src) return '';
    if (typeof src === 'object') src = src.src || '';
    if (src.indexOf('//') === 0) src = 'https:' + src;
    return src + (src.indexOf('?') === -1 ? '?' : '&') + 'width=' + width;
  }

  function handleFromUrl(url) {
    var m = String(url || '').match(/\/products\/([^\/?#]+)/);
    return m ? decodeURIComponent(m[1]) : null;
  }

  function hasOnlyDefaultVariant(p) {
    return p.variants.length === 1 && /^default title$/i.test(p.variants[0].title);
  }

  function lockScroll(on) {
    document.documentElement.classList.toggle('omb-qa-lock', on);
  }

  /* ---------------- Cart count badge ---------------- */
  var cartCount = Number(CONFIG.cartCount) || 0;
  var refreshTimer;
  var originalFetch = window.fetch.bind(window);

  function renderCount(bump) {
    document.querySelectorAll('a.cart-icon, a.sticky-cart-icon').forEach(function (link) {
      var badge = link.querySelector('.omb-cart-count');
      if (!badge) {
        badge = document.createElement('span');
        badge.className = 'omb-cart-count';
        badge.setAttribute('aria-hidden', 'true');
        link.appendChild(badge);
      }
      badge.textContent = cartCount > 99 ? '99+' : String(cartCount);
      badge.hidden = !(cartCount > 0);
      link.setAttribute('aria-label', 'Cart, ' + cartCount + (cartCount === 1 ? ' item' : ' items'));
      if (bump && cartCount > 0) {
        badge.classList.remove('is-bump');
        void badge.offsetWidth;
        badge.classList.add('is-bump');
      }
    });
  }

  function refreshCount(bump) {
    clearTimeout(refreshTimer);
    refreshTimer = setTimeout(function () {
      originalFetch(ROOT + 'cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (cart) {
          if (!cart) return;
          var changed = cart.item_count !== cartCount;
          cartCount = cart.item_count;
          renderCount(bump && changed);
        })
        .catch(function () {});
    }, 150);
  }

  // Keep the count right when anything else on the site changes the cart.
  window.fetch = function (input) {
    var promise = originalFetch.apply(window, arguments);
    try {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      if (/\/cart\/(add|change|update|clear)/.test(url)) {
        promise.then(function (res) { if (res && res.ok) refreshCount(true); }).catch(function () {});
      }
    } catch (e) {}
    return promise;
  };
  window.addEventListener('cart:updated', function () { refreshCount(true); });
  window.addEventListener('pageshow', function (e) { if (e.persisted) refreshCount(false); });

  /* ---------------- Product data ---------------- */
  var productCache = {};
  function fetchProduct(handle) {
    if (productCache[handle]) return Promise.resolve(productCache[handle]);
    return originalFetch(ROOT + 'products/' + encodeURIComponent(handle) + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { if (!r.ok) throw new Error('product'); return r.json(); })
      .then(function (p) { productCache[handle] = p; return p; });
  }

  /* =====================================================
     BACK IN STOCK POPUP
     ===================================================== */
  var bis = document.getElementById('omb-bis');
  if (bis.parentNode !== document.body) document.body.appendChild(bis);
  var bisEls = {
    img: bis.querySelector('.omb-bis__img'),
    title: bis.querySelector('.omb-bis__title'),
    size: bis.querySelector('.omb-bis__size'),
    price: bis.querySelector('.omb-bis__price'),
    form: bis.querySelector('.omb-bis__body'),
    email: bis.querySelector('.omb-bis__input'),
    error: bis.querySelector('.omb-bis__error'),
    submit: bis.querySelector('.omb-bis__submit')
  };
  var bisState = { product: null, variant: null, lastFocus: null, timer: null };

  function openBis(product, variant, trigger) {
    clearTimeout(bisState.timer);
    bisState.product = product;
    bisState.variant = variant;
    bisState.lastFocus = trigger || document.activeElement;

    var image = (variant && variant.featured_image) || product.featured_image;
    bisEls.img.src = sizedImage(image, 160);
    bisEls.img.alt = product.title;
    bisEls.title.textContent = product.title;
    var showSize = variant && !hasOnlyDefaultVariant(product);
    var optionName = (product.options && product.options[0] && (product.options[0].name || product.options[0])) || 'Size';
    bisEls.size.textContent = showSize ? (product.options.length > 1 ? variant.title : optionName + ': ' + variant.title) : '';
    bisEls.size.hidden = !showSize;
    renderPriceInto(bisEls.price, variant ? variant.price : product.price, variant ? variant.compare_at_price : product.compare_at_price);

    bisEls.error.textContent = '';
    bisEls.submit.disabled = false;
    bis.classList.remove('is-done');
    bis.classList.add('is-open');
    bis.setAttribute('aria-hidden', 'false');
    lockScroll(true);
    setTimeout(function () { bisEls.email.focus({ preventScroll: true }); }, 30);
  }

  function closeBis() {
    if (!bis.classList.contains('is-open')) return;
    clearTimeout(bisState.timer);
    bis.classList.remove('is-open', 'is-done');
    bis.setAttribute('aria-hidden', 'true');
    lockScroll(false);
    if (bisState.lastFocus && bisState.lastFocus.focus) bisState.lastFocus.focus({ preventScroll: true });
  }

  function bisFields(email) {
    var p = bisState.product, v = bisState.variant;
    var size = v && !hasOnlyDefaultVariant(p) ? v.title : '-';
    var link = SHOP_URL + p.url + (v ? '?variant=' + v.id : '');
    return {
      'contact[email]': email,
      'contact[name]': 'Back in stock request',
      'contact[Product]': p.title,
      'contact[Size]': size,
      'contact[SKU]': (v && v.sku) || '-',
      'contact[Variant ID]': v ? String(v.id) : '-',
      'contact[Product link]': link,
      'contact[body]': 'BACK IN STOCK REQUEST\n' +
        'Customer email: ' + email + '\n' +
        'Product: ' + p.title + '\n' +
        'Size: ' + size + '\n' +
        'SKU: ' + ((v && v.sku) || '-') + '\n' +
        'Link: ' + link
    };
  }

  // Sends the request through the theme's real Shopify contact form into a
  // hidden frame. Resolves 'ok' when Shopify confirms, or 'challenge' when
  // Shopify wants the shopper to pass its spam check first.
  var contactForm = document.getElementById('omb-bis-contact');
  var contactFrame = document.getElementById('omb-bis-frame');

  function sendBisRequest(fields) {
    return new Promise(function (resolve, reject) {
      if (!contactForm || !contactFrame) { reject(new Error('form')); return; }
      Object.keys(fields).forEach(function (name) {
        var input = contactForm.querySelector('[name="' + name + '"]');
        if (input) input.value = fields[name];
      });

      var done = false;
      var timer = setTimeout(function () { finish(reject, new Error('timeout')); }, 20000);
      function finish(fn, arg) {
        if (done) return;
        done = true;
        clearTimeout(timer);
        contactFrame.removeEventListener('load', onLoad);
        fn(arg);
      }
      function onLoad() {
        var href = '';
        var doc = null;
        try { href = contactFrame.contentWindow.location.href; doc = contactFrame.contentDocument; } catch (err) {}
        if (href.indexOf('/challenge') !== -1) { finish(resolve, 'challenge'); return; }
        if (href.indexOf('contact_posted=true') !== -1) { finish(resolve, 'ok'); return; }
        if (doc && doc.querySelector('#omb-bis-contact .errors, .form__message[role="alert"], .errors')) {
          finish(reject, new Error('form'));
          return;
        }
        finish(resolve, 'ok');
      }
      contactFrame.addEventListener('load', onLoad);
      contactForm.target = 'omb-bis-frame';
      contactForm.submit();
    });
  }

  bisEls.form.addEventListener('submit', function (e) {
    e.preventDefault();
    var email = bisEls.email.value.trim();
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)) {
      bisEls.error.textContent = 'Please enter a valid email address.';
      bisEls.email.focus();
      return;
    }
    bisEls.error.textContent = '';
    bisEls.submit.disabled = true;
    bisEls.submit.textContent = 'Sending…';

    sendBisRequest(bisFields(email))
      .then(function (result) {
        bisEls.submit.textContent = 'Email me when available';
        if (result === 'challenge') {
          // Shopify wants a quick spam check: show it in the main window.
          contactForm.target = '_top';
          contactForm.submit();
          return;
        }
        bis.classList.add('is-done');
        bisState.timer = setTimeout(closeBis, THANKS_DURATION);
      })
      .catch(function () {
        bisEls.submit.disabled = false;
        bisEls.submit.textContent = 'Email me when available';
        bisEls.error.textContent = 'Something went wrong. Please try again.';
      });
  });

  bis.addEventListener('click', function (e) {
    if (e.target.closest('[data-omb-bis-close]')) { e.preventDefault(); closeBis(); }
  });

  /* ---------------- Open the store's cart ---------------- */
  // Clicks the visible header cart icon exactly like a shopper would, so the
  // side cart app (YourToken) opens its drawer. If nothing intercepts the
  // click, the browser simply follows the link to the cart page.
  function openStoreCart() {
    var links = document.querySelectorAll('a.cart-icon, a.sticky-cart-icon, a[href$="/cart"]');
    var target = null;
    for (var i = 0; i < links.length; i++) {
      var r = links[i].getBoundingClientRect();
      if (r.width > 0 && r.height > 0) { target = links[i]; break; }
    }
    if (target) target.click();
    else window.location.href = CART_URL;
  }

  /* =====================================================
     QUICK ADD POPUP (collection + slider cards)
     ===================================================== */
  var modal = document.getElementById('omb-qa');
  if (modal.parentNode !== document.body) document.body.appendChild(modal);
  var els = {
    box: modal.querySelector('.omb-qa__box'),
    img: modal.querySelector('.omb-qa__img'),
    title: modal.querySelector('.omb-qa__title'),
    links: modal.querySelectorAll('[data-omb-link]'),
    rating: modal.querySelector('.omb-qa__rating'),
    ratingValue: modal.querySelector('.omb-qa__rating-value'),
    price: modal.querySelector('.omb-qa__price'),
    loading: modal.querySelector('.omb-qa__loading'),
    options: modal.querySelector('.omb-qa__options'),
    stock: modal.querySelector('.omb-qa__stock'),
    qty: modal.querySelector('.omb-qa__qty'),
    qtyValue: modal.querySelector('.omb-qa__qty span'),
    qtyMinus: modal.querySelector('[data-omb-qty="-1"]'),
    error: modal.querySelector('.omb-qa__error'),
    add: modal.querySelector('.omb-qa__add'),
    notify: modal.querySelector('.omb-qa__notify'),
    close: modal.querySelector('.omb-qa__close')
  };
  var state = { product: null, selected: [], qty: 1, requestId: 0, lastFocus: null };

  function setLinks(url) { els.links.forEach(function (a) { a.href = url; }); }

  function currentVariant() {
    var p = state.product;
    if (!p) return null;
    if (hasOnlyDefaultVariant(p)) return p.variants[0];
    return p.variants.find(function (v) {
      return v.options.every(function (opt, i) { return opt === state.selected[i]; });
    }) || null;
  }

  function isValueAvailable(index, value) {
    return state.product.variants.some(function (v) {
      if (!v.available || v.options[index] !== value) return false;
      return v.options.every(function (opt, i) { return i === index || opt === state.selected[i]; });
    });
  }

  function renderOptions() {
    var p = state.product;
    els.options.textContent = '';
    if (!p || hasOnlyDefaultVariant(p)) return;

    p.options.forEach(function (opt, index) {
      var name = typeof opt === 'string' ? opt : opt.name;
      var values = (opt && opt.values) ? opt.values.slice() : [];
      if (!values.length) {
        p.variants.forEach(function (v) {
          if (values.indexOf(v.options[index]) === -1) values.push(v.options[index]);
        });
      }

      var group = document.createElement('div');
      group.className = 'omb-qa__option';
      group.setAttribute('role', 'radiogroup');
      group.setAttribute('aria-label', name);

      var label = document.createElement('p');
      label.className = 'omb-qa__option-label';
      label.textContent = name + ': ' + (state.selected[index] || '');
      group.appendChild(label);

      var pills = document.createElement('div');
      pills.className = 'omb-qa__pills';

      values.forEach(function (value) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'omb-qa__pill';
        btn.textContent = value;
        btn.setAttribute('role', 'radio');
        var selected = state.selected[index] === value;
        if (selected) btn.classList.add('is-selected');
        if (!isValueAvailable(index, value)) {
          btn.classList.add('is-soldout');
          btn.setAttribute('aria-label', value + ' (out of stock)');
        }
        btn.setAttribute('aria-checked', selected ? 'true' : 'false');
        btn.addEventListener('click', function () {
          state.selected[index] = value;
          els.error.textContent = '';
          renderOptions();
          updateVariantState();
        });
        pills.appendChild(btn);
      });

      group.appendChild(pills);
      els.options.appendChild(group);
    });
  }

  function updateVariantState() {
    var p = state.product;
    if (!p) return;
    var v = currentVariant();

    renderPriceInto(els.price, v ? v.price : p.price, v ? v.compare_at_price : p.compare_at_price);
    var image = (v && v.featured_image) || p.featured_image;
    if (image) els.img.src = sizedImage(image, 240);
    setLinks(p.url + (v && !hasOnlyDefaultVariant(p) ? '?variant=' + v.id : ''));

    var available = !!(v && v.available);
    els.stock.hidden = !v;
    els.stock.textContent = available ? 'In stock' : 'Out of stock';
    els.stock.className = 'omb-qa__stock ' + (available ? 'is-in' : 'is-out');
    els.qty.hidden = !available;
    els.notify.hidden = !(v && !v.available);

    if (!v) {
      els.add.disabled = true;
      els.add.textContent = 'Unavailable';
    } else if (!v.available) {
      els.add.disabled = true;
      els.add.textContent = OUT_OF_STOCK_TEXT;
    } else {
      els.add.disabled = false;
      els.add.textContent = 'Add to cart';
    }
  }

  function setQty(q) {
    state.qty = Math.max(1, Math.min(99, q));
    els.qtyValue.textContent = String(state.qty);
    els.qtyMinus.disabled = state.qty <= 1;
  }

  function prefillFromCard(card) {
    if (!card) return;
    var img = card.querySelector('img.main-img') || card.querySelector('img');
    els.img.src = img ? img.currentSrc || img.src : '';
    els.img.alt = img ? img.alt : '';
    var titleEl = card.querySelector('.card__heading a');
    els.title.textContent = titleEl ? titleEl.textContent.trim() : '';
    var ratingEl = card.querySelector('.rating-average');
    if (ratingEl && ratingEl.textContent.trim()) {
      els.ratingValue.textContent = ratingEl.textContent.trim();
      els.rating.hidden = false;
    } else {
      els.rating.hidden = true;
    }
    var priceEl = card.querySelector('.card-information');
    els.price.textContent = priceEl ? priceEl.textContent.replace(/\s+/g, ' ').trim() : '';
  }

  function openQuickAdd(card, handle, productUrl, trigger) {
    var requestId = ++state.requestId;
    state.product = null;
    state.selected = [];
    state.lastFocus = trigger || document.activeElement;
    setQty(1);
    els.error.textContent = '';
    els.options.textContent = '';
    els.stock.hidden = true;
    els.notify.hidden = true;
    els.qty.hidden = false;
    els.add.disabled = true;
    els.add.textContent = 'Add to cart';
    els.loading.hidden = false;
    els.rating.hidden = true;

    setLinks(productUrl || ROOT + 'products/' + handle);
    prefillFromCard(card);

    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    lockScroll(true);
    els.close.focus({ preventScroll: true });

    fetchProduct(handle).then(function (p) {
      if (requestId !== state.requestId) return;
      state.product = p;
      els.title.textContent = p.title;
      if (!els.img.getAttribute('src')) els.img.src = sizedImage(p.featured_image, 240);
      var first = p.variants.find(function (v) { return v.available; }) || p.variants[0];
      state.selected = first.options.slice();
      els.loading.hidden = true;
      renderOptions();
      updateVariantState();
    }).catch(function () {
      if (requestId !== state.requestId) return;
      window.location.href = productUrl || ROOT + 'products/' + handle;
    });
  }

  function closeQuickAdd(keepLock) {
    if (!modal.classList.contains('is-open')) return;
    state.requestId++;
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    if (!keepLock) {
      lockScroll(false);
      if (state.lastFocus && state.lastFocus.focus) state.lastFocus.focus({ preventScroll: true });
    }
  }

  function addToCart() {
    var v = currentVariant();
    if (!v || !v.available || els.add.classList.contains('is-loading')) return;

    els.error.textContent = '';
    els.add.classList.add('is-loading');
    els.add.textContent = 'Adding…';

    originalFetch(ROOT + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ items: [{ id: v.id, quantity: state.qty }] })
    })
      .then(function (r) { return r.json().then(function (data) { return { ok: r.ok, data: data }; }); })
      .then(function (res) {
        els.add.classList.remove('is-loading');
        if (!res.ok) {
          els.add.textContent = 'Add to cart';
          els.error.textContent = (res.data && (res.data.description || res.data.message)) ||
            'Could not add this item. Please try again.';
          return;
        }
        // Close this popup, then open the store's own cart (YourToken side cart).
        els.add.textContent = 'Add to cart';
        refreshCount(true);
        closeQuickAdd(true);
        lockScroll(false);
        setTimeout(openStoreCart, 60);
      })
      .catch(function () {
        els.add.classList.remove('is-loading');
        els.add.textContent = 'Add to cart';
        els.error.textContent = 'Could not add this item. Please check your connection and try again.';
      });
  }

  els.add.addEventListener('click', addToCart);
  els.notify.addEventListener('click', function () {
    var p = state.product, v = currentVariant();
    if (!p) return;
    var trigger = state.lastFocus;
    closeQuickAdd(true);
    openBis(p, v, trigger);
  });

  modal.addEventListener('click', function (e) {
    if (e.target.closest('[data-omb-close]')) { e.preventDefault(); closeQuickAdd(false); return; }
    var qtyBtn = e.target.closest('[data-omb-qty]');
    if (qtyBtn) setQty(state.qty + Number(qtyBtn.getAttribute('data-omb-qty')));
  });

  // Card buttons. Listening on window in the capture phase means this runs
  // before any app script can turn the click into a direct add-to-cart.
  function cardTrigger(target) {
    var btn = target.closest && target.closest('[data-omb-quick-add], .minimal-card .add-to-cart-form button, .tags-card .add-to-cart-form button');
    if (!btn) return null;
    var card = btn.closest('.minimal-card, .tags-card');
    var url = btn.getAttribute('data-product-url') ||
      (card && card.querySelector('a[href*="/products/"]') && card.querySelector('a[href*="/products/"]').getAttribute('href'));
    var handle = handleFromUrl(url);
    return handle ? { btn: btn, card: card, handle: handle, url: url } : null;
  }

  window.addEventListener('click', function (e) {
    var t = cardTrigger(e.target);
    if (!t) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    openQuickAdd(t.card, t.handle, t.url, t.btn);
  }, true);

  window.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.closest || !form.closest('.minimal-card, .tags-card')) return;
    var t = cardTrigger(form.querySelector('button') || form);
    if (!t) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    openQuickAdd(t.card, t.handle, t.url, t.btn);
  }, true);

  /* =====================================================
     KEYBOARD (both popups)
     ===================================================== */
  function trapFocus(e, container) {
    var focusables = Array.prototype.filter.call(
      container.querySelectorAll('a[href], button:not([disabled]), input:not([disabled])'),
      function (el) { return el.offsetParent !== null && el.tabIndex !== -1; }
    );
    if (!focusables.length) return;
    var first = focusables[0], last = focusables[focusables.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }

  document.addEventListener('keydown', function (e) {
    var openBox = bis.classList.contains('is-open') ? bis : (modal.classList.contains('is-open') ? modal : null);
    if (!openBox) return;
    if (e.key === 'Escape') { openBox === bis ? closeBis() : closeQuickAdd(false); return; }
    if (e.key === 'Tab') trapFocus(e, openBox);
  });

  /* =====================================================
     PRODUCT PAGE: "Out of stock" text + Notify me button
     ===================================================== */
  function selectedVariantOf(productInfo) {
    var el = productInfo.querySelector('variant-selects [data-selected-variant]');
    if (!el || !el.textContent.trim()) return null;
    try { return JSON.parse(el.textContent); } catch (err) { return null; }
  }

  var NOTIFY_GAP = 14;

  function lowestBottom(el) {
    var bottom = el.getBoundingClientRect().bottom;
    el.querySelectorAll('*').forEach(function (child) {
      var r = child.getBoundingClientRect();
      if (r.height > 0 && r.bottom > bottom) bottom = r.bottom;
    });
    return bottom;
  }

  function nextVisibleBlock(btn, stopAt) {
    var el = btn;
    while (el && el !== stopAt) {
      var sib = el.nextElementSibling;
      while (sib) {
        if (sib.getBoundingClientRect().height > 0) return sib;
        sib = sib.nextElementSibling;
      }
      el = el.parentElement;
    }
    return null;
  }

  // Makes the space above the button (to Buy Now) and below it (to the next
  // section) both equal NOTIFY_GAP, whatever margins the theme/apps use.
  function evenOutNotifyGap(btn, productForm, productInfo) {
    if (btn.hidden || !btn.offsetParent) return;
    var top = 0, bottom = 0;
    btn.style.marginTop = '0px';
    btn.style.marginBottom = '0px';
    for (var i = 0; i < 4; i++) {
      var gapAbove = btn.getBoundingClientRect().top - lowestBottom(productForm);
      var diff = NOTIFY_GAP - gapAbove;
      if (Math.abs(diff) < 1) break;
      top += diff;
      btn.style.marginTop = Math.round(top) + 'px';
    }
    var next = nextVisibleBlock(btn, productInfo);
    if (!next) { btn.style.marginBottom = NOTIFY_GAP + 'px'; return; }
    for (var j = 0; j < 4; j++) {
      var gapBelow = next.getBoundingClientRect().top - btn.getBoundingClientRect().bottom;
      var diff2 = NOTIFY_GAP - gapBelow;
      if (Math.abs(diff2) < 1) break;
      bottom += diff2;
      btn.style.marginBottom = Math.round(bottom) + 'px';
    }
  }

  function setupProductPage() {
    if (window.variantStrings) {
      var oldSoldOut = window.variantStrings.soldOut;
      window.variantStrings.soldOut = OUT_OF_STOCK_TEXT;
      document.querySelectorAll('product-form .product-form__submit[disabled] > span').forEach(function (span) {
        if (span.textContent.trim() === String(oldSoldOut).trim()) span.textContent = OUT_OF_STOCK_TEXT;
      });
    }

    document.querySelectorAll('product-info').forEach(function (productInfo) {
      var productForm = productInfo.querySelector('product-form');
      var handle = handleFromUrl(productInfo.dataset.url);
      if (!productForm || !handle || productInfo.dataset.ombNotify) return;
      productInfo.dataset.ombNotify = 'true';

      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'omb-notify-btn';
      btn.textContent = 'Notify me when available';
      btn.hidden = true;
      productForm.insertAdjacentElement('afterend', btn);

      var spacingTimer;
      function respace() {
        clearTimeout(spacingTimer);
        spacingTimer = setTimeout(function () { evenOutNotifyGap(btn, productForm, productInfo); }, 50);
      }

      function update() {
        var v = selectedVariantOf(productInfo);
        var wasHidden = btn.hidden;
        btn.hidden = !(v && v.available === false);
        if (!btn.hidden && wasHidden) respace();
      }
      function updateSoon() { setTimeout(update, 60); setTimeout(update, 700); }

      productInfo.addEventListener('change', updateSoon);
      if (typeof window.subscribe === 'function' && window.PUB_SUB_EVENTS) {
        window.subscribe(window.PUB_SUB_EVENTS.variantChange, updateSoon);
      }
      update();
      respace();

      // The Buy Now button is injected later by an app, so re-check when the
      // area around the button changes size, on resize and after full load.
      if ('ResizeObserver' in window) {
        var ro = new ResizeObserver(respace);
        ro.observe(productForm);
      }
      window.addEventListener('resize', respace);
      window.addEventListener('load', respace);

      btn.addEventListener('click', function () {
        var v = selectedVariantOf(productInfo);
        fetchProduct(handle).then(function (p) {
          var full = v && p.variants.find(function (x) { return x.id === v.id; });
          openBis(p, full || v, btn);
        }).catch(function () {});
      });
    });
  }

  function onReady() {
    renderCount(false);
    setupProductPage();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', onReady);
  } else {
    onReady();
  }

  window.OMBQuickAdd = { open: openQuickAdd, close: closeQuickAdd, openNotify: openBis, refreshCount: refreshCount };
})();
